import { NotificationList } from './notification-list/notification-list';

const Notifications = ({ isRead }: any) => {
  return <NotificationList isRead={isRead} />;
};

export default Notifications;
